import { Dialog, DialogContent, DialogTitle } from '@/components/ui/dialog';

/**
 * The full-screen window the editor modals live in (rate chart, advertisement posters …): the app's shadcn Dialog stretched over
 * the whole screen, above the page chrome (z-200; the export dialogs sit at 260). It draws no close button of its own — the
 * editor's header has the red one — and Esc still closes it through `onClose`. `title` is for screen readers only.
 *
 * Radix mounts the children only while it is open, so anything inside starts fresh on every opening.
 */
export default function EditorWindow({ open, onClose, title, children }) {
    return (
        <Dialog open={open} onOpenChange={(next) => { if (!next) onClose?.(); }}>
            <DialogContent
                showClose={false}
                aria-describedby={undefined}
                className="p-0 overflow-hidden gap-0 z-[200] max-w-none w-full rounded-none top-0 bottom-0 translate-y-0 left-0 translate-x-0 border-0 flex flex-col"
                overlayClassName="z-[199]"
                style={{ position: 'fixed', top: 0, bottom: 0, left: 0, right: 0, transform: 'none', height: '100svh' }}
            >
                <DialogTitle className="sr-only">{title}</DialogTitle>
                {children}
            </DialogContent>
        </Dialog>
    );
}
